export default __webpack_public_path__ + "static/media/Bandit's Tunic of the Covert Trail.d296ae9d.jpg";